module.exports = __webpack_public_path__ + "static/media/PLA_test_report.6a009076.png";